/**
 * Enumération définissant les différentes valeurs applicables au filtrage sur une date
 */
enum DELTA_DATE {
  DATE_PASSEE = "Date passée",
  INF_1_MOIS = "< 1 Mois",
  INF_2_MOIS = "< 2 Mois",
  INF_6_MOIS = "< 6 Mois",
  INF_12_MOIS = "< 12 Mois",
  INF_24_MOIS = "< 24 Mois",
  INF_36_MOIS = "< 36 Mois",
}
export default DELTA_DATE;
